/**
 * 日志管理
 */
export default {
  sysOperateLogpageList: "/sysOperateLog/pageList", // 分页
}
